
import Vue from "vue"
let vm = {
  data: () => {
    return {
      btn: 'up',
      filterText: '',
      isShowBtn: true,
      dropdownStyle:{ width: '10rem'}
    }
  },
  props: {
    inputPlaceholder: String,
    options: Array,
    value: {
      default: 2022
    }
  },
  methods: {
    changeBtn() {
      if (this.btn === 'up') {
        this.btn = 'down'
      } else {
        this.btn = 'up'
      }
    },
    handleProvinceChange(value) {
      this.filterText = value
      this.btn = 'up'
      this.onFilter()
    },
    onFilter() {
      this.$emit('input', this.filterText)
      if (this.$refs.input) {
        this.$refs.input.blur()
      }
    },
    onBlur() {
      this.btn = 'up'
    },
    inputBlur() {
      this.isShowBtn = true
      this.onFilter()
    },
    selectOpen() {
      this.$refs.select.focus()
    },
    onClear() {

    }
  },
  watch: {
    value() {
      this.filterText = this.value
    }
  }
}
export default vm


// WEBPACK FOOTER //
// ./src/supplychain/js/FilterBtn.js